import { store } from '@/plugins/pinia';
import { getAnalytics } from '@/services/analytics';
import { useAuthStore } from '@/stores/useAuthStore';
import { useWhoAmIStore } from '@/stores/useWhoAmIStore';
import { watch } from 'vue';

let isAnalyticsUserIdSyncInitialized = false;

export function setupAnalyticsUserIdSync(): void {
  if (isAnalyticsUserIdSyncInitialized) return;
  isAnalyticsUserIdSyncInitialized = true;

  queueMicrotask(startAnalyticsUserIdSync);
}

function startAnalyticsUserIdSync(): void {
  const authStore = useAuthStore(store);
  const whoAmIStore = useWhoAmIStore(store);
  let lastAppliedUserId: string | null | undefined;

  watch(
    () => (authStore.csrfToken != null && whoAmIStore.whoAmI?.id != null ? String(whoAmIStore.whoAmI.id) : null),
    (userId) => {
      if (userId === null && lastAppliedUserId === undefined) return;
      if (userId === lastAppliedUserId) return;

      getAnalytics().setUserId(userId);
      getAnalytics().setUserData(userId === null ? null : { id: userId, email: whoAmIStore.whoAmI!.email });
      lastAppliedUserId = userId;
    },
    { immediate: true, flush: 'sync' },
  );
}
